export const LIST_PROFILES_START = 'LIST_PROFILES_START';
export const LIST_PROFILES_SUCCESS = 'LIST_PROFILES_SUCCESS';
export const LIST_PROFILES_ERROR = 'LIST_PROFILES_ERROR';
export const LIST_PROFILES_END = 'LIST_PROFILES_END';
